import moment from 'moment';

export class Validation {
  public static canSendInvoiceOrderToRivhit(date: Date) {
    const prevMonthCloseDay = 15;
    const prevMonthCloseDate = moment().date(prevMonthCloseDay);
    const dateInSameMonth = prevMonthCloseDate.month() === moment(date).month()
      && prevMonthCloseDate.year() === moment(date).year();
    const januaryMonthIndex = 0;
    const decemberMonthIndex = 11;
    const dateInPreviousMonth = moment().month() === januaryMonthIndex
      ? moment(date).month() === decemberMonthIndex
      : moment().month() - moment(date).month() === 1;
    if (moment().isSameOrAfter(prevMonthCloseDate, 'day')) {
      return dateInSameMonth;
    } else {
      return dateInSameMonth || dateInPreviousMonth;
    }
  }
}